import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { EventsService } from 'angular4-events';
declare var $: any;
declare var toastr: any;
@Component({
  selector: 'app-chains',
  templateUrl: './chains.component.html',
  styleUrls: ['./chains.component.css']
})
export class ChainsComponent implements OnInit {
  ChainName: any = '';
  showSearchResults:any;
  searchBusinessDetailforOrder = [];
  serviceCity = -1;
  dispensary_id:any;
  editChainName:any;
  getname: any;
  searchstring:any;
  index:any;
  getstring:any;
  button_to_hide:any;
  businessForOrders = 'ADD'
  selected_var = 'false';
  addRoleBtn = true;
  disableClick:any;
  delete_id:any;
  businessName:any;
  Businessid:any;
  showdata:any;
  getchain:any=[];
  isChecked:any;
  productTypeName:any;
  editData:any;
  getchainName:any;
  button_to_show:any;
  id:any;
  is_show_always:boolean = false;
  removeSuccess:any;
  added_Data:any;
  constructor(private dataService: DataService) { }
  businessNames:any =[];
  addslot=[{
    value:''
  }]
  editslot=[{
    value:''
  }]
  is_add:any = true;
  check_show:any;
  is_show:any=[];
  business:any = [];
  edittbusiness:any = [];
  searchBusiness:any = [];
  showDetail:boolean = false;
  editChain:any = [];
  suggestionShow = [ false];
  openpAddTypePop() {
    this.businessNames=[];
    this.showDetail=false;
    this.is_show_always = false;
    this.button_to_hide=true;
    this.button_to_show=false;
    this.businessNames.push('');
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    this.ChainName='';
    this.searchBusiness=[];
    $('#addProductTypePop').modal('show');
    this.searchBusiness=[];
  }
  addProductTypeFunction()
  {

    if ( this.ChainName === null || this.ChainName === undefined || this.ChainName === '' ) {
      toastr.error('Please add ChainName');
      return;
    }
    console.log("length of search business",this.searchBusiness.length);
    if ( this.searchBusiness.length < 1 ) {
      toastr.error('Please add Business');
      return;
    }
    for(let i=0; i < this.searchBusinessDetailforOrder.length; i++){
    console.log('Check Condition', this.searchBusinessDetailforOrder, this.searchBusinessDetailforOrder[i].length === 0);
    if(this.searchBusinessDetailforOrder[i].length === 0  && this.searchBusiness[i]!=this.searchBusinessDetailforOrder[i].dispensary_name)
          {
            toastr.error('invalid id');
            return;
          }
        }
    console.log("name",this.businessNames.length);
        //
        for(let j=0; j < this.searchBusiness.length;j++)
      {
        this.businessNames[j]=this.searchBusiness[j];
      }
    //
    for(let i=0; i < this.businessNames.length;i++)
    {

      if ( this.businessNames[i]=='') {
        toastr.error('Please add Business');
        return;
      }
    }
    this.dataService.getchain(window.localStorage.getItem('token'), this.ChainName,this.business).subscribe(
      (data) => {

      this.added_Data=data;
      if(this.added_Data.rest_error_code!=1)
      {
      console.log("added",this.added_Data);
      toastr.success(this.added_Data.Message);
      this.businessNames=[];
      this.addslot=[];
      this.searchBusiness=[];
      this.business=[];
      $('#addProductTypePop').modal('hide');
      this.shoechain();
       this.businessNames=[];
       this.searchBusiness=[];
       this.business=[];
      }
      else
      {
        toastr.error(this.added_Data.Error);
      }
    },
      (error) => {
        //this.nao.go(100);
        console.log('error', error);
        toastr.error('error Exist');
      }
    );
  }
  addnewSlot()
  {

    //this.searchBusiness[i]=[]
    console.log("Hello");

    this.searchBusinessDetailforOrder.push([]);
    this.suggestionShow.push(false);
    if(this.is_show_always==false)
    {
      this.businessNames.push('');
    }
    else
    {
      this.businessNames.push('');
      this.editChain.push(
        {
          'id':'',
          'is_show_always':false
        });
    }
  }
  removeslot(i)
  {

    console.log("index",this.businessNames)
    if(this.businessNames.length > 1)
  {
    if(this.is_show_always==false)
  {
   this.businessNames.splice(i,1);
   this.searchBusiness.splice(i,1);
   this.business.splice(i,1);
  //  this.searchBusiness[i]='';
  }
  else
  {
    this.businessNames.splice(i,1);
    this.editChain.splice(i,1)
    this.searchBusiness.splice(i,1);
    this.is_show.splice(i,1);
    // this.searchBusiness[i]='';
  }
}
}
  searchSpecificBusiness(i)
   {
    console.log("hello there")
    this.selected_var = 'false';
    if(this.searchBusiness[i] != undefined && this.searchBusiness[i]!=='')
    {
    // setTimeout(() => {

      this.dataService.getdispensaryListingById(localStorage.getItem('token'), this.serviceCity, this.searchBusiness[i]).subscribe(
        (data) => {

          this.showSearchResults = true;
          console.log("filter",data);
          this.searchBusinessDetailforOrder[i] = data;
          this.suggestionShow[i] = this.searchBusinessDetailforOrder[i].length != 0 ? true : false;
        },

        (error) => {
          console.log('error', error);

        }
      );
    // });
  }
  }
  getdispansaryName(p)
  {

    this.check_show=!this.is_show[p];
    this.editChain[p].is_show_always = this.check_show;
  }
  dispansaryName(businessName,dispensary_id,i)
  {

    if(this.is_show_always==false)
    {

    this.Businessid=dispensary_id;
    this.business.push(
      {
      'dispensary_id': this.Businessid,
      'is_show_always': false
      }
    )
    }
    else
    {
    this.editChain[i]['id'] = dispensary_id;

    }
      console.log(dispensary_id);
    // this.searchBusinessDetailforOrder[i]=[];
    this.suggestionShow[i] = false;
    console.log("Name",businessName);
    //this.searchstring=businessName;
    this.searchBusiness[i] = businessName;

  }
shoechain()
{
  this.dataService.showchain(window.localStorage.getItem('token'),).subscribe(
    (data) => {
    console.log("chain data",data);
    this.showdata = data;
    this.showdata = this.showdata.chain_list;
    },
    (error) => {
      console.log('error', error);

    }
  );
}
detaildfuction(chain_id)
{
  this.showDetail=true;
  $('#addProductTypePop').modal('show');
  this.dataService.get_dispensaries_chain(window.localStorage.getItem('token'),chain_id).subscribe(
    (data) => {
          console.log("chaindata",data);
          this.getchain=data;
          this.getchain = this.getchain.chain_with_dispensaries;
          this.getchainName=this.getchain.chain_name;
          this.getchain = this.getchain.items;
    },
    (error) => {
      console.log('error', error);

    }
  );
}
clearSearch(i) {
  this.searchstring = '';
  this.searchSpecificBusiness(i);
}
editbusiness(obj,chain_id)
{
  this.businessNames=[];
  this.button_to_show=true;
  this.id=chain_id;
  this.button_to_hide = false;
  this.is_show_always = true;
  this.showDetail=false;
  this.ChainName=obj.chain_name;

  this.dataService.get_dispensaries_chain(window.localStorage.getItem('token'),chain_id).subscribe(
    (data) => {
          console.log("chaindata",data);
          this.editChain=data;
          this.editChain = this.editChain.chain_with_dispensaries;
          this.getchainName=this.editChain.chain_name;
          this.editChain = this.editChain.items;
          this.searchBusiness=this.editChain.map(element => {
            return element.name;
          });
          this.is_show=this.editChain.map(element => {
            return element.is_show_always;
          });
          console.log("edit",this.editChain)
           this.businessNames = JSON.parse(JSON.stringify(this.editChain));

    },
    (error) => {
      console.log('error', error);

    }
  );
   //this.productTypeName = obj.productTypeName;
   //$('#mybutton').css('display', 'none');
   setTimeout(()=>{
     $('#addProductTypePop').modal('show');
   },300)
  //  this.button_to_hide = true;

}
editProductTypeFunction()
{
  let edit_chain:any;
  if ( this.ChainName === null || this.ChainName === undefined || this.ChainName === '' ) {
    toastr.error('Please add ChainName');
    return;
  }
  if ( this.searchBusiness.length < 1 )
  {
    toastr.error('Please add Business');
    return;
  }
  console.log("bus",this.businessNames);
  console.log("item",this.editChain);
  // for(let i=0; i < this.searchBusinessDetailforOrder.length; i++){
    // debugger;
    // console.log('Check Condition', this.searchBusinessDetailforOrder, this.searchBusinessDetailforOrder[i].length === 0);
    // if(this.searchBusinessDetailforOrder[this.editChain].length === 0  && this.searchBusiness[i]!=this.searchBusinessDetailforOrder[i].dispensary_name)
    // for(let i=0; i < this.editChain.length;i++)
    // {
    // if(this.editChain[i].id=='')
    //       {
    //         toastr.error('invalid id');
    //         return;
    //       }
    //     }

  console.log("searchbusiness",this.searchBusiness);
  console.log("checkbox",this.is_show);
  console.log("item",this.editChain);
  console.log("bus",this.businessNames);

for(let j=0; j < this.searchBusiness.length;j++)
{
  this.businessNames[j]=this.searchBusiness[j];
}
//
for(let i=0; i < this.businessNames.length;i++)
{

if ( this.businessNames[i]=='') {
  toastr.error('Please add Business');
  return;
}
}
for(let i=0; i < this.editChain.length;i++)
 {

    if(this.editChain[i].id=='')
          {
            toastr.error('invalid id');
            return;
          }

   }
  //  Duplicate product //
for(let j=0; j < this.editChain.length;j++)
{
  for(let i=j+1; i < this.editChain.length;i++)
  {
  if(this.editChain[j].id===this.editChain[i].id)
  {
  if(this.editChain[j].is_show_always===this.editChain[i].is_show_always)
  {
    toastr.error('Duplicates are not allowed');
    return;
  }
}
}
}
  let len = this.editChain.length;

  console.log("items length",len);
  for (let i = 0; i < len; i++)
  {
    delete this.editChain[i].name;
  }
  this.dataService.get_edit_chain(window.localStorage.getItem('token'),this.id,this.ChainName,this.editChain).subscribe(
    (data) => {
      console.log("data",data)
       this.editData=data;
       if(this.editData.rest_error_code!=1)
       {
       this.shoechain();
        toastr.success(this.editData.Message);
       }
       else
       {
        toastr.error(this.editData.Error);
       }
        $('#addProductTypePop').modal('hide');
        this.businessNames = [];
      },
          (error) => {
            console.log('error', error);
          }
          );

}
openPop(i)
{
  this.delete_id = i;
  $('#productTypeRemovePop').modal('show');
}
removeProductType(getid)
{
  this.dataService.delete_chain(window.localStorage.getItem('token'), getid).subscribe(
    (data) => {

      this.removeSuccess = data;
      $('#productTypeRemovePop').modal('hide');
      toastr.success("Deleted successfully");
      this.shoechain();
    }
    );
}
  ngOnInit() {
      this.shoechain();
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#chains').css('color', '#d77229');
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
  }

}



// WEBPACK FOOTER //
// ./src/app/chains/chains.component.ts